import './GroomerSelect.scss';

import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';

import Checkout from 'organisms/Checkout';
import { trackCheckout } from 'util/tracking/events';

import GroomerInfo from './GroomerInfo';

export default function GroomerSelect() {
  const dispatch = useDispatch();
  const requestAppointmentForm = useSelector(
    (state) => state.requestAppointmentForm,
  );

  useEffect(() => {
    dispatch(trackCheckout(requestAppointmentForm));
  }, []);

  return (
    <>
      <Helmet title="Select a groomer for your booking | PawCare" />
      <Checkout className="p-0">
        <GroomerInfo />
      </Checkout>
    </>
  );
}
